import LangSelector from './components/lang-selector';
import CatalogSearchForm from './components/catalog-search-form';
import ProductOETable from './components/product-oe-number-table';
import TabsGroup from './components/tabs-group';
import ImagesGallery from './components/images-gallery';

import CalorstatWebservice from './services/calorstat-webservice';

import DeviceManager from './utils/device-manager';

(function($) {
    window.$ = $;
    const lang = typeof cal.lang !== 'undefined' ? cal.lang : 'en';

    $(function() {
        const $html = $('html');

        // Touch device detection
        if(DeviceManager.isHandheld()) {
            $html.addClass('touch');

            if(DeviceManager.isIos()) {
                $html.addClass('ios');
            }
        }
        else {
            $html.addClass('no-touch');
        }

        // IE detection
        if(DeviceManager.isIe10()) {
            $html.addClass('ie10');
        }
        else if(DeviceManager.isIe11()) {
            $html.addClass('ie11');
        }
        else if(DeviceManager.isEdge()) {
            $html.addClass('edge');
        }

        // General components
        new LangSelector($('.language-selector'));
        new CatalogSearchForm($('.catalog-search-form'));

        // Product details page components
        const $productOETable = $('.product-oe-number-table.datatable');
        if($productOETable.length) {
            new ProductOETable($productOETable);
        }

        const $imagesGallery = $('.images-gallery');
        if($imagesGallery.length) {
            new ImagesGallery($imagesGallery);
        }

        const $tabsGroups = $('.tabs-group');
        if($tabsGroups.length) {
            new TabsGroup($tabsGroups);
        }

        // Cookie consent
        if(typeof tarteaucitron !== 'undefined' && tarteaucitron) {
            // Tarteaucitron cookie settings
            let tarteaucitronLang = cal.lang || 'en';

            if(cal.lang === 'cn') {
                tarteaucitronLang = 'en';
            }

            window.tarteaucitronForceLanguage = tarteaucitronLang; /* supported: fr, en, de, es, it, pt, pl, ru */
            tarteaucitron.init({
                "privacyUrl": "", /* Privacy policy url */

                "hashtag": "#tarteaucitron", /* Open the panel with this hashtag */
                "cookieName": "tarteaucitron", /* Cookie name */

                "orientation": "bottom", /* Banner position (top - bottom) */
                "showAlertSmall": false, /* Show the small banner on bottom right */
                "cookieslist": true, /* Show the cookie list */

                "adblocker": false, /* Show a Warning if an adblocker is detected */
                "AcceptAllCta" : true, /* Show the accept all button when highPrivacy on */
                "highPrivacy": false, /* Disable auto consent */
                "handleBrowserDNTRequest": false, /* If Do Not Track == 1, disallow all */

                "removeCredit": true, /* Remove credit link */
                "moreInfoLink": false, /* Show more info link */
                "useExternalCss": false, /* If false, the tarteaucitron.css file will be loaded */

                //"cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for multisite */

                "readmoreLink": "/mentions-legales" /* Change the default readmore link */
            });

            // Add Google Analytics job
            tarteaucitron.user.gtagUa = 'G-13EL9NBC0W';
            tarteaucitron.user.gtagMore = function () { /* add here your optionnal gtag() */ };
            (tarteaucitron.job = tarteaucitron.job || []).push('gtag');
        }

        const $cookieLink = $('.cookie-link');
        if($cookieLink.length && typeof tarteaucitron !== 'undefined' && tarteaucitron) {
            $cookieLink.on('click', tarteaucitron.userInterface.openPanel);
        }
    });

})(jQuery);
